<script lang="ts" setup>
import { SwiperSlide } from 'swiper/vue'
import type { CarouselProduct } from '~/types/Product'
import SliderCard from './Product/SliderCard.vue'

const props = defineProps<{
  products: CarouselProduct[]
}>()
</script>

<template>
  <FullSlider>
    <template #sliderContent>
      <SwiperSlide v-for="(product, index) in props.products" :key="index">
        <SliderCard v-bind="product" />
      </SwiperSlide>
    </template>
  </FullSlider>
</template>
